import * as Yup from 'yup';

import { ALLOWED_CHARACTERS_REGEX } from '@/common/constants';

export const registerSchema = () =>
    Yup.object({
        type: Yup.string()
            .trim()
            .required('Type is required'),
        email: Yup.string()
            .trim()
            .required('Email is required')
            .email('Enter a valid email address'),
        firstName: Yup.string()
            .trim()
            .required('First name is required')
            .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
            .max(50, 'Max length is 50 characters'),
        lastName: Yup.string()
            .trim()
            .required('Last name is required')
            .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
            .max(50, 'Max length is 50 characters'),
        password: Yup.string()
            .trim()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters long')
            .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
            .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
            .matches(/\d/, 'Password must contain at least one number')
            .matches(/[^a-zA-Z0-9]/, 'Password must contain at least one special character (e.g., !, @, #, $)'),
        confirmPassword: Yup.string()
            .trim()
            .required('Confirm password is required')
            .oneOf([Yup.ref('password')], 'Passwords must match')
    });
